/**
 * English UI dictionary. Must keep the exact same key shape as pl.ts
 * (enforced by a type constraint in index.ts).
 */
import type { Dictionary } from "../types.js";

export const en: Dictionary = {
	common: {
		skipToContent: "Skip to content",
		loading: "Loading…",
		error: "An error occurred",
		retry: "Try again",
		close: "Close",
		menu: "Menu",
		search: "Search",
		searchPlaceholder: "What are you looking for?",
		readMore: "Read more",
		backHome: "Back to home",
		demoBadge: "DEMO",
	},
	nav: {
		services: "Services",
		companies: "Companies",
		caseStudies: "Case studies",
		knowledge: "Knowledge base",
		resources: "Reports & resources",
		webinars: "Webinars",
		contact: "Contact",
		search: "Search",
	},
	switcher: {
		language: "Language",
		polish: "Polish",
		english: "English",
		theme: "Theme",
		light: "Light",
		dark: "Dark",
		system: "System",
	},
	form: {
		required: "This field is required",
		invalidEmail: "Invalid email address",
		invalidPhone: "Invalid phone number",
		consentRequired: "Consent is required",
		submit: "Send",
		submitting: "Sending…",
		success: "Thank you. Your message has been sent.",
		genericError: "The form could not be sent. Please try again.",
		duplicate: "We have already received your submission.",
	},
	errors: {
		notFoundTitle: "Page not found",
		notFoundBody: "The page you are looking for does not exist or has been moved.",
		serverTitle: "Something went wrong",
		serverBody: "We are working on it. Please try again in a moment.",
	},
	assistant: {
		title: "AI Assistant",
		placeholder: "Ask about the Group's services…",
		disclaimer: "Answers are indicative (feature in preparation).",
	},
};
